import { render, staticRenderFns } from "./FeatureDetailsCard.vue?vue&type=template&id=6edc57f6"
import script from "./FeatureDetailsCard.vue?vue&type=script&lang=js"
export * from "./FeatureDetailsCard.vue?vue&type=script&lang=js"
import style0 from "../../scss/infoCards.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./FeatureDetailsCard.vue?vue&type=style&index=1&id=6edc57f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports